import Axios from "axios";
import Vue from "vue";

class Errors {
    constructor(errors = null) {
        this._errors = {};
        this.set({});

        if (errors && typeof errors === "object") {
            this.set(errors);
        }
    }

    set(errors) {
        Vue.set(this, "_errors", errors);
    }

    get(key) {
        let error = this._errors[key];

        return Array.isArray(error) ? error[0] : null;
    }

    all() {
        return this._errors;
    }

    empty() {
        return Object.keys(this._errors).length <= 0;
    }
}

class ApiResponse {
    constructor(data) {
        this._original = data;
        this._errors = new Errors();
        this._data = {};

        Vue.set(this, "_errors", new Errors());
        Vue.set(this, "_data", {});

        if (data instanceof Error) {
            console.log(data);

            Vue.set(this, "_data", data.response.data);
            this._errors.set(this._data.errors);
        } else {
            Vue.set(this, "_data", data.data.data);
        }
    }

    data() {
        return this._data;
    }

    hasErrors() {
        return !this._errors.empty();
    }

    errors() {
        return this._errors;
    }

    error(key) {
        return this._errors.get(key);
    }
}

export default class Api {
    constructor() {
        this.apiVersion = "v1";
        this.base = `/api/${this.apiVersion}/`;

        this.client = Axios.create({
            baseURL: this.base,
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        });

        this.clientTemp = Axios.create({
            baseURL: `${window.location.protocol}//${window.location.host}/api/v1/`,
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        });
    }

    errors() {
        return new Errors();
    }

    async getTemp(path, query = {}, options = {}) {
        try {
            return await this.response(
                await this.clientTemp.get(path, {
                    ...options,
                    params: query
                })
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    async get(path, query = {}, options = {}) {
        try {
            return await this.response(
                await this.client.get(path, {
                    ...options,
                    params: query
                })
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    /**
     *
     * @param path
     * @param data
     * @param options
     * @returns {Promise<ApiResponse>}
     */
    async post(path, data = {}, options = {}) {
        try {
            return await this.response(
                await this.client.post(path, data, options)
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    /**
     *
     * @param path
     * @param data
     * @param options
     * @returns {Promise<ApiResponse>}
     */
    async patch(path, data = {}, options = {}) {
        try {
            return await this.response(
                await this.client.patch(path, data, options)
            );
        } catch (e) {
            return await this.response(e);
        }
    }

    /**
     *
     * @param data
     * @returns {Promise<ApiResponse>}
     */
    async response(data) {
        return new ApiResponse(data);
    }
}
